import Vue from 'vue'

import { Prop } from 'vue-property-decorator'
import { Mixin } from 'vue-mixin-decorator'

@Mixin
export class Selectable extends Vue {

  @Prop({ required: false, default: false })
  selected: boolean

  @Prop({ required: false })
  select: (value: string) => void

  protected get selectableStyles () {
    let styleClasses = ['selectable']

    if (this.selected === true) {
      styleClasses.push('selected')
    }

    return styleClasses
  }

}
